//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import CustomWidgetLoader from "~/components/common/CustomWidgetLoader.vue";
export default {
  components: {
    CustomWidgetLoader
  },
  data() {
    return {
      isLoader: false,
      formBody: {
        user_name: "",
        email: "",
        question_title: "",
        question: "",
        files: [],
        specialist_id: "",
        user_id: "",
        answer: ""
      },
      rows: [
        {
          title: 'Имя',
          type: 'input',
          connection: 'user_name',
        },
        {
          title: 'Электронная почта',
          type: 'input',
          connection: 'email',
          error: false,
        },
        {
          title: 'Заголовок вопроса',
          type: 'input',
          connection: 'question_title',
          error: false,
        },
        {
          title: 'Ваш вопрос',
          type: 'textarea',
          connection: `question`,
          error: false
        },
      ]
    }
  },
  methods: {
    createImageUrl(image) {
      return URL.createObjectURL(image);
    },
    onFileChange(event) {
      let _formBody = {...this.formBody};
      let _files = [...(_formBody.files || [])];
      _files = [..._files, ...(event.target.files || [])];
      _formBody.files = _files;
      this.formBody = _formBody;
    },
    removeFile(file) {
      let _formBody = {...this.formBody};
      let _files = [...(_formBody.files || [])];
      _files = _files.filter((item) => item !== file);
      _formBody.files = _files;
      this.formBody = _formBody;
    },
    isEmailValid (value = '') {
      return String(value)
        .toLowerCase()
        .match(
          /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        )
    },
    isFormValidation() {
      this.formBody.email = this.formBody.email.trim()

      if (!this.isEmailValid(this.formBody.email)) {
        this.$toast.error('Проверьте заполнение email')
        return false
      }
      if (!this.formBody.question_title || this.formBody.question_title.length < 1) {
        this.$toast.error('Заполните заголовок вопроса')
        return false
      }
      if (!this.formBody.question || this.formBody.question.length < 1) {
        this.$toast.error('Введите ваш вопрос')
        return false
      }
      return true
    },
    submitForm: async function() {
      this.isLoader = true

      if (this.$store.state.user.user) {
        this.formBody.user_id = this.$store.state.user.user.id
      }

      if (!this.isFormValidation()) {
        this.isLoader = false
        return
      }

      const formData = new FormData();
      Object.keys(this.formBody).map((_key) => {
        if (_key === 'files') {
          this.formBody[_key].map((item, index) => {
            formData.append('files[]', item)
          })
        } else {
          formData.append(_key, this.formBody[_key])
        }
      })
      const submitFormResponse = await this.$api.agent.transport.post('questions-specialist', formData).then((res) => {
        this.$store.commit(
          "send-quest-notification/openSendQuestNotification",
          {
            message: 'Ваш вопрос отправлен',
            params: {
              type: "info"
            }
          }
        )
        this.resetForm()
        this.isLoader = false
        return true
      }).catch((err) => {
        this.$toast.error(err?.response?.data?.message || 'Ошибка сервера, проверьте данные')
        this.isLoader = false
        return false
      })
    },
    resetForm() {
      const resetBody = {
        user_name: "",
        email: "",
        question_title: "",
        question: "",
        files: [],
        specialist_id: "",
        user_id: "",
        answer: ""
      }
      this.formBody = resetBody
    },
  }
}
